module.exports = __webpack_public_path__ + "static/grrmartin-240e93160eb589dc6c5ebca580ff91d5.gif";